<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
      }}</b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">{{ alert_error_message
      }}</b-alert>

    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <!-- Template Name -->
        <b-form-group id="grp_txt_template_name" label="Template Name:" label-for="txt_template_name" label-size="sm">
          <b-form-input id="txt_template_name" type="text" required placeholder="Enter template name"
            v-model="address_obj.template_name"></b-form-input>
        </b-form-group>

        <!-- Name -->
        <b-form-group id="grp_txt_name" label="Name:" label-for="txt_name" label-size="sm">
          <b-form-input id="txt_name" type="text" required placeholder="Enter name"
            v-model="address_obj.name"></b-form-input>
        </b-form-group>

        <!-- Phone -->
        <b-form-group id="grp_txt_phone" label="Phone:" label-for="txt_phone" label-size="sm">
          <b-form-input id="txt_phone" type="text" required placeholder="Enter phone"
            v-model="address_obj.phone"></b-form-input>
        </b-form-group>

        <!-- District Dropdown -->
        <b-form-group id="grp_select_district" label="District:" label-for="select_district" label-size="sm">
          <b-form-select id="select_district" v-model="address_obj.district" :options="district_options"
            required></b-form-select>
        </b-form-group>

        <!-- Address -->
        <b-form-group id="grp_txt_address" label="Address:" label-for="txt_address" label-size="sm">
          <b-form-textarea id="txt_address" required placeholder="Enter full address" v-model="address_obj.address"
            rows="3"></b-form-textarea>
        </b-form-group>

        <!-- Remark -->
        <b-form-group id="grp_txt_remark" label="Remark:" label-for="txt_remark" label-size="sm">
          <b-form-textarea id="txt_remark" placeholder="Enter remark" v-model="address_obj.remark"
            rows="2"></b-form-textarea>
        </b-form-group>

        <!-- Submit Button -->
        <b-button class="float-right" type="submit" variant="primary" @click="addAddress">Submit</b-button>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import global_function from "../mixins/global_function";
import { validationMixin } from "vuelidate";
import apiService from "../services/ApiService";

export default {
  name: "OrderAddressAdd",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  mixins: [validationMixin, global_function, apiService],
  data() {
    return {
      breadcrumb_items: [
        {
          text: "Address Template",
          to: { name: "address_template" }
        },
        {
          text: "Form",
          active: true
        }
      ],
      address_obj: {
        template_name: "",
        name: "",
        phone: "",
        district: "",
        address: "",
        remark: "" // Added remark field
      },
      district_options: [], // Dropdown options for districts
      showAlert_success: false,
      alert_success_message: "",
      showAlert_error: false,
      alert_error_message: "",
    };
  },
  async created() {
    await this.loadDistrictOptions(); // Load districts when the component is created
  },
  methods: {
    async loadDistrictOptions() {
      try {
        // Fetch districts and populate the dropdown
        let districts_response = await this.getDistricts(this.$store.state.user_obj);
        for (let i in districts_response.districts) {
          this.district_options.push({
            value: districts_response.districts[i].district,
            text: districts_response.districts[i].district
          });
        }
      } catch (error) {
        console.error("Error loading districts:", error);
      }
    },

    async addAddress() {
      // Validation
      if (this.address_obj.template_name.trim() === "") {
        this.alert_error_message = `Template Name is required`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
        }, 3000);
        return;
      }

      if (this.address_obj.name.trim() === "") {
        this.alert_error_message = `Name is required`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
        }, 3000);
        return;
      }

      if (this.address_obj.phone.trim() === "") {
        this.alert_error_message = `Phone is required`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
        }, 3000);
        return;
      }

      if (this.address_obj.district.trim() === "") {
        this.alert_error_message = `District is required`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
        }, 3000);
        return;
      }

      if (this.address_obj.address.trim() === "") {
        this.alert_error_message = `Address is required`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
        }, 3000);
        return;
      }

      // Construct the request payload with the required fields
      const payload = {
        template_name: this.address_obj.template_name,
        name: this.address_obj.name,
        phone: this.address_obj.phone,
        district: this.address_obj.district,
        address: this.address_obj.address,
        remark: this.address_obj.remark, // Include remark in the payload
        created_by: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id
      };

      // Add or Edit Address logic
      if (this.$route.params.order_address_id) {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "order_address_edit.php",
          data: {
            address_id: this.$route.params.order_address_id,
            ...payload  // Spread the payload
          }
        });

        if (response.data.status === "success") {
          this.alert_success_message = `Address Updated Successfully.`;
          this.showAlert_success = true;
          setTimeout(() => {
            this.showAlert_success = false;
          }, 3000);
          this.$router.go(-1);
        } else {
          alert(response.data.error_msg);
        }
      } else {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "address_template_add.php", // Ensure it points to the correct API endpoint
          data: payload  // Send the payload directly
        });

        if (response.data.status === "success") {
          this.alert_success_message = `Address Created Successfully.`;
          this.showAlert_success = true;
          setTimeout(() => {
            this.showAlert_success = false;
          }, 3000);
          this.$router.go(-1);
        } else {
          alert(response.data.error_msg);
        }
      }
    }

  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/AddressTemplateAdd.vue